import * as R from 'ramda';
import { ValidatorUtils } from './utils';

export const maxLengthValidator = {
    message(field: string, args: any) {
        const max = R.is(Array, args) || '0' in args ? args[0] : args.length;
        return `'${ValidatorUtils.prettifyName(field)}' must have a length shorter than ${max} characters`;
    },
    validate(value: any, args: any) {
        const max = R.is(Array, args) ? args[0] : args.length;
        if (!isNaN(value)) value = value.toString();
        if (R.isNil(value) || R.isEmpty(value) || !R.is(String, value) || value.length > max) {
            return false;
        }
        return true;
    },
};
